<template>
  <a-result
    status="500"
    title="500"
    sub-title="抱歉，服务器发生错误。"
  >
    <template #extra>
      <a-button type="primary" @click="toHome">
        返回首页
      </a-button>
    </template>
  </a-result>
</template>

<script>
export default {
  methods: {
    toHome () {
      window.location.href = '/'
    }
  },
  mounted () {
    const params = {
      errorCode: 500,
      pageUrl: this.$router.history._startLocation,
      systemCode: 'SSO_SYS_USER'
    }

    if (!params.pageUrl.startsWith('/500')) {
      this.$store
        .dispatch('DingTalkNotice', params)
        .finally(() => {
          // eslint-disable-next-line no-console
          console.log('-> 子应用访异常:', params)
        })
    }
  }
}
</script>
